export default {
	"order.ExchangeSuccessfully": "Exchange successfully",
	"order.NoActivationAddress": "No activation address!"
}